import { jsx as _jsx } from "react/jsx-runtime";
import { lazy, Suspense, useMemo } from 'react';
import { useIconsTheme } from '../../context';
export default function ArrowLeft(props) {
    const theme = useIconsTheme();
    const Icon = useMemo(() => {
        switch (theme) {
            case 'base':
                return lazy(() => import('../svg/base/ArrowLeft'));
            case 'bosch':
                return lazy(() => import('../svg/bosch/ArrowLeft'));
            case 'gaggenau':
                return lazy(() => import('../svg/gaggenau/ArrowLeft'));
            case 'siemens':
                return lazy(() => import('../svg/siemens/ArrowLeft'));
        }
    }, [theme]);
    return (_jsx(Suspense, { fallback: _jsx("svg", { ...props, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }), children: _jsx(Icon, { ...props }) }));
}
//# sourceMappingURL=ArrowLeft.js.map